var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.pageReady)?_c('div',[_c('authentication-interceptor',[_c('accept-policies-interceptor',[_c('dossier-detail-component',{attrs:{"detail-definition-id":_vm.activityDefinition.dossiers.entries[0].dossierDetailDefinitionId,"activity-name":_vm.activityDefinition.name}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }